import { defaultLocale, type Locale } from "@/lib/i18n/locales";

import { GesellschaftsrechtSolutionEnum, type Solution } from "./types";

/**
 * German hub keeps canonical order (M&A not first). Other locales surface M&A first.
 */
export function orderGesellschaftsrechtSolutionsForLocale(
  solutions: Record<string, Solution>,
  locale: Locale,
): Record<string, Solution> {
  if (locale === defaultLocale) {
    return solutions;
  }
  const mAndA = GesellschaftsrechtSolutionEnum.MAndA;
  if (!(mAndA in solutions)) {
    return solutions;
  }
  const orderedKeys = [
    mAndA,
    ...Object.keys(solutions).filter((k) => k !== mAndA),
  ];
  const out: Record<string, Solution> = {};
  for (const k of orderedKeys) {
    out[k] = solutions[k]!;
  }
  return out;
}
